import request from '@/router/axios'
import env from '@/config/env'
import globalVariable from '@/config/globalVariable'

const { TIME } = globalVariable

/**
 * 获取定制客运财务统计合计
 * @param customFinanceQueryParam
 */
export const selectCustomSumTotal = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/customSumTotal',
    method: 'POST',
    timeout: TIME,
    data: customFinanceQueryParam
  })
}

/**
 * 根据供应商进行财务统计
 * @param customFinanceQueryParam
 */
export const selectCustomFinancePage = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/customFinancePage',
    method: 'POST',
    timeout: TIME,
    data: customFinanceQueryParam
  })
}

/**
 * 根据供应商导出定制客运财务统计
 * @param customFinanceQueryParam
 */
export const exportCustomFinanceByMerchant = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportCustomByMerchant',
    method: 'GET',
    timeout: TIME,
    param: customFinanceQueryParam
  })
}

/**
 * 根据车辆导出定制客运财务统计
 * @param customFinanceQueryParam
 */
export const exportCustomFinanceByCar = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportCustomByCar',
    method: 'GET',
    timeout: TIME,
    param: customFinanceQueryParam
  })
}

/**
 * 根据线路导出定制客运财务统计
 * @param customFinanceQueryParam
 */
export const exportCustomFinanceByLine = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportCustomByLine',
    method: 'GET',
    timeout: TIME,
    param: customFinanceQueryParam
  })
}

/**
 * 摆渡服务费统计
 * @param customFinanceQueryParam
 */
export const selectFerryServerMoney = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/pageFerryAmount',
    method: 'POST',
    timeout: TIME,
    data: customFinanceQueryParam
  })
}

/**
 *导出摆渡服务费
 */
export const selectFerryServerByLine = (merchantId, exportType) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportFerryAmount',
    method: 'GET',
    timeout: TIME,
    params: {
      merchantId: merchantId,
      exportType: exportType
    }
  })
}

/**
 *摆渡结算统计
 * @param customFinanceQueryParam
 */
export const selectFerrySettleMoney = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '//financeAdmin/v2/statis-ferry-page',
    method: 'GET',
    timeout: TIME,
    params: customFinanceQueryParam
  })
}

/**
 * 导出摆渡服务费
 * @param customFinanceQueryParam
 */
export const exportFerryServerMoney = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportFerryAmount',
    method: 'GET',
    timeout: TIME,
    param: customFinanceQueryParam
  })
}

/**
 * 导出摆渡结算
 * @param customFinanceQueryParam
 */
export const exportFerrySettleMoney = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportFerrySettle',
    method: 'GET',
    timeout: TIME,
    param: customFinanceQueryParam
  })
}

/**
 * 同城财务统计分页数据
 * @param customFinanceQueryParam
 */
export const selectSameCityFinancePage = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/pageFinaceByMechant',
    method: 'POST',
    timeout: TIME,
    data: customFinanceQueryParam
  })
}

/**
 * 导出同城财务统计
 * @param customFinanceQueryParam
 */
export const exportSameCityFinance = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportSameCityFinance',
    method: 'GET',
    timeout: TIME,
    data: customFinanceQueryParam
  })
}

/**
 * 按司机导出同城财务统计
 * @param customFinanceQueryParam
 */
export const exportSameCityFinanceByCar = (customFinanceQueryParam) => {
  return request({
    url: env.ferryUrl + '/financeAdmin/exportSameCityFinanceByCar',
    method: 'GET',
    timeout: TIME,
    param: customFinanceQueryParam
  })
}

/**
 * 根据供应商查询线路
 */
export const getLineByMerchantIdList = (merchantId) => {
  return request({
    url: env.ferryUrl + '/lineAdmin/getLineByMerchantIds',
    method: 'GET',
    timeout: TIME,
    param: merchantId
    // params: {
    //     merchantId: merchantId
    // }
  })
}

/**
 *获取所有线路
 */
export const getAllRoute = () => {
  return request({
    url: env.ferryUrl + '/stationRuleAdmin/findAllLine',
    //url: 'http://192.168.1.131:38000/stationRuleAdmin/findAllLine',
    method: 'GET',
    timeout: TIME
  })
}
